var render = function render(){var _vm=this,_c=_vm._self._c;return _c('arrow-left',{staticClass:"itserve-menu-icon",attrs:{"fill-color":_vm.appTheme === 'dark' ? '#0562ad' : '#ffffff'},on:{"click":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }